import firebase from "firebase";
import "firebase/firebase-app"
import "firebase/firestore"

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCOho0-YPJnSKrZk746aekCgmQokFYH7NE",
    authDomain: "journey-through-my-journal.firebaseapp.com",
    projectId: "journey-through-my-journal",
    storageBucket: "journey-through-my-journal.appspot.com",
    messagingSenderId: "187262079811",
    appId: "1:187262079811:web:7e8648f7f9d25132e795f6",
    measurementId: "G-40LLDYZLWH"
  };

  firebase.initializeApp(firebaseConfig);

  export default firebase;